export default __webpack_public_path__ + "static/media/banner.d2b34389.png";